import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import useCart from '@hooks/useCart';
import useTranslations from '@hooks/useTranslation';
import moment from 'moment';
import TagTemplate from '@ui/Tag/Tag';
import { formatMoneyToCZK } from '@utils/cart.utils';
import { IDate, IModule, ITicket } from '../../interfaces/Conference';
import { calendarApi } from '../../services/calendar.service';
import {
    Ticket,
    TicketAnswer,
    TicketAnswers,
    TicketButton,
    TicketCanceled,
    TicketLabel,
    TicketPrice,
    TicketPriceNoVat,
    TicketPriceWithButton,
    TicketQuestion,
    TicketSoldOut,
    TicketTitle,
    Tags,
} from './ConferenceTickets.elements';

interface ConferenceProps {
    colors?: Object;
    ticket?: ITicket;
    type?: Number;
}

const ConferenceTicketTemplate: FC<ConferenceProps> = ({ colors, ticket, type }) => {
    const { t } = useTranslations();

    const { addOrUpdateItemInCart } = useCart();

    const [date, setDate] = useState<IDate>();
    const [quantities, setQuantities] = useState({});

    const loadDateByKey = async (dateKey: string) => {
        const response = await calendarApi.getDateData(dateKey);
        setDate(response.data);
    };

    useEffect(() => {
        if (ticket?.date?._key) {
            loadDateByKey(ticket?.date?._key);

            (quantities as { [key in string]: number })[ticket?.date?._key] = 1;
            setQuantities(quantities);
        }
    }, [ticket?.date?._key]);

    const priceTicket = date?.modules?.filter((item) => item?.type === 0);
    const a = moment(date?.eventDate?.to);
    const b = moment(date?.eventDate?.from);
    const diffDays = a.diff(b, 'days') + 1;

    const handleBuyClick = () => {
        const top = document.getElementById('confSection14').offsetTop;
        return window.scrollTo({ top: top - 60, behavior: 'smooth' });
    };

    return (
        <Ticket colors={colors}>
            <TicketTitle colors={colors}>{ticket.name}</TicketTitle>
            <TicketLabel colors={colors}>
                {diffDays > 1 && (
                    <>
                        ({diffDays} {t('conference.general.dayOfConference')})
                    </>
                )}
            </TicketLabel>
            <TicketQuestion>{t('conference.general.ticketInclude')}</TicketQuestion>
            <TicketAnswers>
                <TicketAnswer dangerouslySetInnerHTML={{ __html: ticket.description }}></TicketAnswer>
            </TicketAnswers>
            <TicketPriceWithButton>
                {priceTicket?.length > 0 && date?.eventDate?.state === 0 && (
                    <>
                    <TicketPrice>
                        {formatMoneyToCZK(priceTicket[0].price_with_vat)} {t('conference.general.currencySign')}{' '}
                        {t('conference.general.withVat')}
                    </TicketPrice>
                    <TicketPriceNoVat>
                        {formatMoneyToCZK(priceTicket[0].price)} {t('conference.general.currencySign')}{' '}
                        {t('conference.general.noVat')}
                    </TicketPriceNoVat>
                    </>
                )}
                {date?.eventDate?.state === 0 && type !== 3 && (
                    <TicketButton
                        colors={colors}
                        onClick={() =>
                            addOrUpdateItemInCart(
                                priceTicket[0]?._key,
                                (quantities as { [key in string]: number })[date?.eventDate?._key]
                            )
                        }
                    >
                        {t('conference.general.buyTicket')}
                    </TicketButton>
                )}
               
                {date?.eventDate?.state === 1 && <TicketSoldOut>{t('conference.general.soldOut')}</TicketSoldOut>}
                {date?.eventDate?.state === 2 && <TicketCanceled>{t('conference.general.canceled')}</TicketCanceled>}
            </TicketPriceWithButton>

            {date?.tags?.filter((tag: { label: boolean }) => tag?.label)?.length > 0 && (
                <Tags>
                    {date?.tags
                        ?.filter((tag: { label: boolean }) => tag.label)
                        ?.map((tag: { color: string; title: string }, key: number) => (
                            <TagTemplate key={`tag-${key}`} name={tag.title} color={tag.color} />
                        ))}
                </Tags>
            )}
        </Ticket>
    );
};

export default ConferenceTicketTemplate;
